/**
 * Tallies the raw and possible score for a given array of subnodes.
 * @param {array} subnodes An array of subnode keys to be tallied.
 * @param {object} byNodeScoring From userAssessment.scoring.byNode
 * @returns {object} Total {raw, possible,} score for the subnodes as a whole.
 */
export default function tallyNodeArray (subnodes, byNodeScoring) {
  let raw = 0
  let possible = 0
  subnodes.forEach((subnode) => {
    if (byNodeScoring && byNodeScoring[subnode]) {
      raw += byNodeScoring[subnode].raw
      possible += byNodeScoring[subnode].possible
    }
  })
  return {
    raw,
    possible,
  }
}
    


    


// WEBPACK FOOTER //
// ./src/helpers/assessment/tallyNodeArray.js